"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessageContainer = exports.ErrorIconContainer = exports.ErrorContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ErrorContainer = styled_1.default.div `
  display: flex;
  border: 1px solid #d02937;
  background: #f9dbde;
`;
exports.ErrorIconContainer = styled_1.default.button `
  border-radius: 50%;
  border-width: 0;
  padding: 0 2px 1px 2px;
  margin: 0 ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
  background-color: transparent;
`;
exports.ErrorMessageContainer = styled_1.default.pre `
  color: red;
`;
//# sourceMappingURL=styles.js.map